module.exports = __webpack_public_path__ + "img/vasyr-2019.9c3b5190.jpg";